import type { AssetDescriptor } from "@engine";

// MORPH-HEX asset manifest.
//
// To add or replace an asset:
//   1. Drop the file into ./files/ (create the folder if needed).
//   2. Add or update its entry below.
//
// Missing files are tolerated in dev. The AssetService will warn and skip,
// and consumers should fall back to procedural defaults via assets.tryGet(...).
//
// Asset keys follow `<category>.<group>.<name>` so they remain self-describing.
export const morphHexManifest: AssetDescriptor[] = [
  // Wall textures, one per shape. Optional — SegmentFactory falls back to a
  // procedural emissive material when a key is missing.
  // {
  //   key: "tex.wall.octagon",
  //   kind: "texture",
  //   url: new URL("./files/wall_octagon.png", import.meta.url).href,
  //   options: { wrap: "repeat", anisotropy: 4 },
  // },
  // {
  //   key: "tex.wall.square",
  //   kind: "texture",
  //   url: new URL("./files/wall_square.png", import.meta.url).href,
  //   options: { wrap: "repeat", anisotropy: 4 },
  // },
  // {
  //   key: "tex.wall.triangle",
  //   kind: "texture",
  //   url: new URL("./files/wall_triangle.png", import.meta.url).href,
  //   options: { wrap: "repeat", anisotropy: 4 },
  // },

  // Environment HDR (optional).
  // { key: "env.tunnel", kind: "hdr", url: new URL("./files/tunnel.hdr", import.meta.url).href },

  // SFX (optional). When absent the game uses synth-only feedback.
  // { key: "sfx.death", kind: "audio", url: new URL("./files/death.wav", import.meta.url).href },
  // { key: "sfx.gate",  kind: "audio", url: new URL("./files/gate.wav",  import.meta.url).href },
];
